import { useEffect, useRef, useState } from "react";
import { useLoader } from "@react-three/fiber";
import { AudioListener, AudioLoader } from "three";

const useSound = (file, props) => {
  const ref = useRef();
  const [listener] = useState(() => new AudioListener());
  const buffer = useLoader(AudioLoader, file);

  useEffect(() => {
    ref.current.setBuffer(buffer);
  }, []);

  return {
    element: <positionalAudio ref={ref} args={[listener]} {...props} />,
    ref: ref.current,
  };
};

export default useSound;
